module.exports = __webpack_public_path__ + "img/pic_310613_3.79df485c.jpg";